import { useEffect } from 'react';
import { applyBrandAccent } from '@/lib/brand';
import { useAuth } from '@/contexts/AuthContext';
import { useTheme } from '@/contexts/ThemeContext';

/**
 * Repaints `--primary` (and its derived foreground/text variants) whenever the
 * signed-in organization or the resolved theme changes.
 *
 * Renders nothing — it exists so the tenant accent is a single effect in one
 * place rather than something every component has to remember.
 */
export function BrandAccent() {
  const { org } = useAuth();
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    applyBrandAccent(org?.brand_primary ?? null, resolvedTheme);
  }, [org?.brand_primary, resolvedTheme]);

  return null;
}
